import Phaser from 'phaser';
import { initPlayerInventory } from '../player-state';
import { createDefaultWorldModels } from '../components/world-model';
import { queueStageLoad } from '../components/stage';
import { queueGeodeLoad, prepareGeode } from '../components/geode';
import { queueWeaponLoad, prepareWeapon } from '../components/weapon';
import { queueBoogasLoad } from '../components/boogas';
import { queueMenuGeodeIconsLoad } from '../ui/menu-geode-icon';
import { emitGame, GameEvents } from '../events';
import { updateGameLoadingProgress } from '../../ui/game-loading';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload() {
    updateGameLoadingProgress(0.02, 'Loading assets…');

    this.load.on('progress', (value: number) => {
      // Leave headroom for scene construction after assets finish.
      updateGameLoadingProgress(0.02 + value * 0.78, 'Loading assets…');
    });

    const world = createDefaultWorldModels();

    queueStageLoad(this);
    queueGeodeLoad(this, world.geode);
    queueWeaponLoad(this);
    queueBoogasLoad(this);

    this.load.image('hud-backpack', 'Misc/Inventory/backpack.png');
    this.load.image('hud-anvil', 'Misc/Inventory/anvil.png');
    this.load.image('hud-dust-icon', 'Misc/Dust Icon.png');
    this.load.image('ui-slot-square', 'Misc/Inventory/Square.png');
    this.load.image('ui-ph-head', 'Misc/Inventory/HelmetPH.png');
    this.load.image('ui-ph-body', 'Misc/Inventory/ClothingPH.png');
    this.load.image('ui-ph-weapon', 'Misc/Inventory/WeaponPH.png');
    this.load.image('item-wood-club', 'Weapons/wood_club/wood_club_icon.png');
    this.load.image('ui-forge-bg', 'Misc/Inventory/Forge bg.png');
    this.load.image('ui-forge-frame', 'Misc/Inventory/Forge frame.png');
    this.load.image('ui-forge-btn', 'Misc/Inventory/forge button.png');
    this.load.image('ui-inventory-frame', 'Misc/Inventory/Frame.png');
    this.load.image('ui-inventory-bg', 'Misc/Inventory/Frame bg.png');

    this.load.image('menu-bar', 'menu/Bar.png');
    this.load.image('menu-secondary-bg', 'menu/Secondary_Background.png');
    this.load.image('menu-main-bg', 'menu/Main_Background.png');
    this.load.image('menu-rank', 'menu/Rank_Button.png');
    this.load.image('menu-shop', 'menu/Shop_Button.png');
    this.load.image('menu-main', 'menu/Main_Button.png');
    this.load.image('menu-weapon', 'menu/Weapon_Button.png');
    this.load.image('menu-booga', 'menu/Booga_Button.png');

    queueMenuGeodeIconsLoad(this);
  }

  create() {
    updateGameLoadingProgress(0.82, 'Building world…');
    const world = createDefaultWorldModels();
    prepareGeode(this, world.geode);
    initPlayerInventory();
    void this.startGame();
  }

  private async startGame() {
    updateGameLoadingProgress(0.9, 'Forging weapon…');
    await prepareWeapon(this);

    updateGameLoadingProgress(0.96, 'Building UI…');
    this.scene.start('WorldScene');
    this.scene.launch('HudScene');
    this.scene.launch('UiScene');

    // Must NOT use this.time — scene.start('WorldScene') shuts BootScene down
    // and cancels its timers, which left the loader stuck on "Building UI".
    window.setTimeout(() => {
      emitGame(GameEvents.GAME_READY);
    }, 50);
  }
}
